// extracted by mini-css-extract-plugin
export var aboveInput = "_le-0";
export var actionButton = "_le-5";
export var actionButtonContainer = "_le-1";
export var actionIcon = "_le-6";
export var aiInfoContainer = "_le-2";
export var attachmentWrapper = "_le-7";
export var bold = "_le-3";
export var checkIcon = "_le-8";
export var clickingRecipientBar = "_le-11";
export var commentThreadSwitch = "_le-a";
export var draftImage = "_le-b";
export var draftImageContainer = "_le-c";
export var draftImages = "_le-e";
export var editButton = "_le-g";
export var editor = "_le-f";
export var editorContainer = "_le-y";
export var editorErrorTooltipWrapper = "_le-9";
export var headerDivider = "_le-h";
export var icon = "_le-i";
export var info = "_le-j";
export var internal = "_le-n";
export var internalDivider = "_le-k";
export var internalMessage = "_le-l";
export var messageInputCard = "_le-m";
export var messageInputForm = "_le-o";
export var messageInputFormInternal = "_le-p";
export var options = "_le-q";
export var publicMessageCustomer = "_le-s";
export var publicMessageMerchant = "_le-r";
export var removeImageButton = "_le-d";
export var replyButtons = "_le-t";
export var showSignatureButton = "_le-u";
export var spinner = "_le-v";
export var verticalButtonDivider = "_le-4";
export var visibilitySelector = "_le-w";
export var warning = "_le-x";
export var wrappingText = "_le-z";
export var writingInternalNoteTopBorder = "_le-10";